import { Box } from "@mui/material";
import ContactUsForm from "src/components/HelpMenu/ContactUs";
import styles from "./homepage.module.css";
import LegalFooterContactUs from "src/components/LegalFooter/LegalFooterContactUs";

function ContactUs() {
  return (
    <Box
      className={styles.appRoot}
      sx={{
        display: "flex",
        flexDirection: "column",
        bgcolor: "#EDEDED",
      }}
    >
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          minHeight: 0,
          overflowY: "auto",
          WebkitOverflowScrolling: "touch",
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": { display: "none" },
        }}
      >
        <ContactUsForm standalone />
      </Box>
      <LegalFooterContactUs />
    </Box>
  );
}

export default ContactUs;
